export const cardMode = {
  CARD_VERIFY: 0x00,
  CARD_ENROLL: 0x01,
};
